'use client';

import { useSyncExternalStore } from 'react';

type DeviceInfo = {
  isDesktop: boolean;
};

const subscribe = () => () => undefined;
const getServerSnapshot = () => false;

function getIsDesktopSnapshot() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile =
    /mobile|android|iphone|ipad|ipod|blackberry|opera mini|iemobile/.test(
      userAgent
    );
  const isTablet =
    /tablet|ipad|playbook|silk/.test(userAgent) ||
    (userAgent.includes('mobile') && !userAgent.includes('mobi'));

  return !isMobile && !isTablet;
}

export function useDeviceDetection(): DeviceInfo {
  return {
    isDesktop: useSyncExternalStore(
      subscribe,
      getIsDesktopSnapshot,
      getServerSnapshot
    ),
  };
}
